import { SET_EVENTS } from '../actions/events';
export var events = function events() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_EVENTS:
      return action.events;
    default:
      return state;
  }
};
export var loadingEvents = function loadingEvents() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_EVENTS:
      return false;
    default:
      return state;
  }
};